import {
  Dropdown,
  DropdownItem,
  DropdownList,
  TableData,
  TableRow
} from '@cokitchen/cokitchen-components';
import moment from 'moment';
import React, { useState } from 'react';
import { formatNumber } from 'utils/functions';
import { EventStatementType } from './types';

const PaymentTableRow = ({
  statement,
  handleDownload
}: {
  statement: EventStatementType;
  handleDownload?: (event_id: string, format: string) => void;
}) => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };
  return (
    <TableRow className='min-w-full payment_table'>
      <TableData>{statement.name}</TableData>
      <TableData>{moment(statement.start_date).format('DD/MM/YYYY')}</TableData>
      <TableData>{moment(statement.end_date).format('DD/MM/YYYY')}</TableData>
      <TableData>{formatNumber(statement.opening_balance)}</TableData>
      <TableData>{formatNumber(statement.closing_balance)}</TableData>
      <TableData className='flex items-end'>
        <Dropdown
          visible={isDropdownOpen}
          onClickOutside={() => setIsDropdownOpen(false)}
          content={
            <button
              onClick={toggleDropdown}
              className='bg-[#F2F2F2] rounded-full px-5 py-2 text-xs font-medium w-fit cursor-pointer'>
              Download
            </button>
          }>
          <DropdownList>
            {['pdf', 'xlsx'].map((format, index) => (
              <DropdownItem
                key={index}
                className='text-sm font-medium text-[#2e3031]'
                onClick={() => {
                  handleDownload?.(statement.event_id, format);
                  toggleDropdown();
                }}>
                {format.toUpperCase()}
              </DropdownItem>
            ))}
          </DropdownList>
        </Dropdown>
      </TableData>
    </TableRow>
  );
};

export default PaymentTableRow;
